import { ContentArticleTemplateContext } from '@contexts/content-article-template'
import { LIST_TEMPLATE, ListTemplateContext } from '@contexts/list-template'
import ContentfulContentArticleCardFormule from '@entries/contentful-content-article-card-formule'
import ContentfulContentArticleCardIconBulle from '@entries/contentful-content-article-card-icon-bulle'
import ContentfulContentArticleCardImage from '@entries/contentful-content-article-card-image'
import ContentfulContentArticleCardImageFull from '@entries/contentful-content-article-card-image-full'
import ContentfulContentArticleCardOffer from '@entries/contentful-content-article-card-offer'
import ContentfulContentArticleCardStage from '@entries/contentful-content-article-card-stage'
import ContentfulContentArticleDefault from '@entries/contentful-content-article-default'
import ContentfulContentArticleRecommendation from '@entries/contentful-content-article-recommendation'
import ContentfulContentArticleRefreshCardPicto from '@entries/contentful-content-article-refresh-card-picto'
import ContentfulContentArticleRefreshCardPictoAlignLeft from '@entries/contentful-content-article-refresh-card-picto-align-left'
import ContentfulContentArticleRefreshCardStage from '@entries/contentful-content-article-refresh-card-stage'
import ContentfulContentArticleRefreshDefault from '@entries/contentful-content-article-refresh-default'
import ContentfulContentArticleRefreshImageBento from '@entries/contentful-content-article-refresh-image-bento'
import ContentfulContentArticleRefreshImageFull from '@entries/contentful-content-article-refresh-image-full'
import ContentfulContentArticleRefreshPicto from '@entries/contentful-content-article-refresh-picto'
import ContentfulContentArticleUnificationTransparentCard from '@entries/contentful-content-article-unification-transparent-card'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { ContentfulContentArticleTemplate } from '@typings/contentful-content-article-template'
import { graphql } from 'gatsby'
import React, { useContext } from 'react'

const ContentfulContentArticle: Utils.EntryFC<
  Queries.ContentfulContentArticleFragment
> = ({ content }) => {
  const pageSectionContentArticleTemplate = useContext(
    ContentArticleTemplateContext
  )
  const template =
    pageSectionContentArticleTemplate ||
    ContentfulContentArticleTemplate.DEFAULT

  return (
    <ListTemplateContext.Provider
      value={
        (content.unorderedListTemplate as LIST_TEMPLATE) || LIST_TEMPLATE.DISC
      }
    >
      <Entry
        content={content}
        mappingKeyResolver={() => template}
        mapping={{
          [ContentfulContentArticleTemplate.CARD_OFFER]:
            ContentfulContentArticleCardOffer,
          [ContentfulContentArticleTemplate.CARD_FORMULE]:
            ContentfulContentArticleCardFormule,
          [ContentfulContentArticleTemplate.CARD_BULLE]:
            ContentfulContentArticleCardIconBulle,
          [ContentfulContentArticleTemplate.CARD_IMAGE_FULL]:
            ContentfulContentArticleCardImageFull,
          [ContentfulContentArticleTemplate.CARD_STAGE]:
            ContentfulContentArticleCardStage,
          [ContentfulContentArticleTemplate.CARD_IMAGE]:
            ContentfulContentArticleCardImage,
          [ContentfulContentArticleTemplate.RECOMMENDATION]:
            ContentfulContentArticleRecommendation,
          [ContentfulContentArticleTemplate.REFRESH_IMAGE_FULL]:
            ContentfulContentArticleRefreshImageFull,
          [ContentfulContentArticleTemplate.REFRESH_IMAGE_BENTO]:
            ContentfulContentArticleRefreshImageBento,
          [ContentfulContentArticleTemplate.REFRESH_CARD_STAGE]:
            ContentfulContentArticleRefreshCardStage,
          [ContentfulContentArticleTemplate.REFRESH_CARD_PICTO]:
            ContentfulContentArticleRefreshCardPicto,
          [ContentfulContentArticleTemplate.REFRESH_DEFAULT]:
            ContentfulContentArticleRefreshDefault,
          [ContentfulContentArticleTemplate.REFRESH_PICTO]:
            ContentfulContentArticleRefreshPicto,
          [ContentfulContentArticleTemplate.REFRESH_CARD_PICTO_ALIGN_LEFT]:
            ContentfulContentArticleRefreshCardPictoAlignLeft,
          [ContentfulContentArticleTemplate.UNIFICATION_TRANSPARENT_CARDS]:
            ContentfulContentArticleUnificationTransparentCard,
          [ContentfulContentArticleTemplate.DEFAULT]:
            ContentfulContentArticleDefault,
        }}
      />
    </ListTemplateContext.Provider>
  )
}

export const query = graphql`
  fragment ContentfulContentArticleTitle on Contentful4TmD9EihHakmKMkEwKaUwQTitle {
    rich
    text
    references {
      ...ContentfulDefaultAsset
      ...ContentfulFootnoteSup
    }
  }

  fragment ContentfulContentArticleSubtitle on Contentful4TmD9EihHakmKMkEwKaUwQSubtitle {
    rich
    references {
      ...ContentfulFootnoteSup
    }
  }

  fragment ContentfulContentArticleContent on Contentful4TmD9EihHakmKMkEwKaUwQContent {
    rich
    references {
      ...ContentfulDefaultAsset
      #...ContentfulBlogTagLink
      #...ContentfulBlogArticleLink
      ...ContentfulDeprecatedPageLink
      ...ContentfulGraphs
      ...ContentfulCta
      ...ContentfulImageInline
      ...ContentfulEmbeddedAsset
      ...ContentfulFootnoteSup
      ...ContentfulStaticPageLink
      ...ContentfulPDFLink
    }
  }

  fragment ContentfulContentArticleImageText on Contentful4TmD9EihHakmKMkEwKaUwQImageText {
    rich
    references {
      ...ContentfulFootnoteSup
    }
  }

  fragment ContentfulContentArticle on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    ...ContentfulContentArticleCardFormule
    ...ContentfulContentArticleCardIconBulle
    ...ContentfulContentArticleCardImageFull
    ...ContentfulContentArticleCardImage
    ...ContentfulContentArticleCardOffer
    ...ContentfulContentArticleCardStage
    ...ContentfulContentArticleRecommendation
    ...ContentfulContentArticleRefreshImageFull
    ...ContentfulContentArticleRefreshCardStage
    ...ContentfulContentArticleRefreshPicto
    ...ContentfulContentArticleDefault
    ...ContentfulContentArticleRefreshCardPicto
    ...ContentfulContentArticleUnificationTransparentCard
    unorderedListTemplate
  }
`

export default withDisplayName(
  ContentfulContentArticle,
  'ContentfulContentArticle'
)
